import { tagsManagers } from '../managers';
import { IExtractorParams } from '../types/params';
import { TTagOption } from '../types/tag';

export const restoreTagsFromJsonQuery = (params: IExtractorParams) =>
  tagsManagers.flatMap(tag => tag.extractTagsFromJsonQuery(params)?.flat()).filter(Boolean) as TTagOption[];
